<div class='managerInfoContainer'>
    <mat-list class='managerInfoList'>
        @if (obj?.firstName && obj?.lastName !== null) {
            <mat-list-item class='managerInfoItem'>
                <div class='icon-text'>
                    <mat-icon class='icon' svgIcon='person'>person</mat-icon>
                    <span>{{ obj.firstName }} {{ obj.lastName }}</span>
                </div>
            </mat-list-item>
        }
        @if (obj?.agentEmail) {
            <mat-list-item class='managerInfoItem'>
                <div class='icon-text'>
                    <mat-icon class='icon' svgIcon='write_email'>write_email</mat-icon>
                    <a href='mailto:{{ obj.agentEmail }}'>{{ obj.agentEmail }}</a>
                </div>
            </mat-list-item>
        }
        @if (obj?.phone) {
            <mat-list-item class='managerInfoItem'>
                <div class='icon-text'>
                    <mat-icon class='icon' svgIcon='phone'>phone</mat-icon>
                    <a href='tel:{{ obj.phone }}'>{{ obj.phone }}</a>
                </div>
            </mat-list-item>
        }

        @if (obj?.msTeams) {
            <mat-list-item class='managerInfoItem'>
                <div class='icon-text'>
                    <mat-icon class='icon' svgIcon='ms_teams'>microsoft-teams</mat-icon>
                    <span>{{ obj.msTeams }}</span>
                </div>
            </mat-list-item>
        }
    </mat-list>
</div>